/**
 * @memberof SMART2
 * @ngdoc directive
 * @name Form-widget
 * @description Form widget directive accepts form-config and model-data. 
 *    ui elements (fields) that are optional are added in right-panel (widget-panel). Optional fields can be added on form by simply clicking that item in right-panel. 
 *    Optional field can also be removed by clicking 'x' icon on the upper right corner of ui element or 'x' icon against that item in right-panel. 
 * 
 * @attr {Array} form-config
 *    Form config is expected to be an array of ui elements (fields)
 * @attr {Object} model-data
 *    Data to be bound on ui elements (fields)
 * @attr {Boolean} is-sequencial
 *    If the value of this attribute is set to true, newly added ui element (field) will be added at the end of the section.
 *    If the value of this attribute is set to false, newly added ui element (field) will be added by the orders it appears in form-config.  
 * @attr {Boolean} show-widget
 *    When form-config is passed to form-widget, right-panel will always be created if this attribute is not set to false.
 * @attr {String} search-holder
 *    Id of DOM element where search bar should appear. This attribute enables form-widget search feature, where user can search for optional sections and fields on the form.
 *    And navigate to optional section or field by clicking on search result item.
 * @attr {Number} widget-panel-top
 *    Top position for widget-panel (right-panel)
 * @attr {Number} widget-panel-right
 *    Right position for widget-panel (right-panel)
 * @attr {Function} on-section-sort
 *    Callback function when sections are sorted or rearranged
 * @attr {Function} on-save
 *    Callback function when sections are need to be save on outside section click
 *
 * @example
 Dynamic:
 Controller:
      $scope.config = {
          modelData: {
              "firstName": "Sushant",
              "lastName": "Ahirrao"
          },    
          formConfig: {
              "sections": [
                  {
                      "isMandatory": true
                      "rows": [
                          {
                              "properties": [
                                  {
                                      "label": "First name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "firstName"
                                  }, {
                                      "label": "Last name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "lastName"
                                  }
                              ]    
                          }
                      ]
                  }
              ]
          },
          "rules": [
              {
                  "rule": "this.firstName == \"Sushant\" && this.lastName != \"Ahirrao\"",
                  "error": "First name and last name combination is not matching"
              }
          ]
      };

  Usage:
      <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>

 * @example
 Dynamic attribute value. One can set a scope variable or function as attribute value. 
 One can also pass parameters in calling function as is done on callback functions.
 In following example, value of 'isMandatory' field for 'Last Name' can be 'isLastNameMandatory(config.modelData)'.
 'options' attribute does not support function as value.
 Controller:
      $scope.isFirstNameMandatory = true;

      $scope.isLastNameMandatory = function() {
            return true;
      };

      $scope.config = {
          modelData: {
              "firstName": "Sushant",
              "lastName": "Ahirrao"
          },    
          formConfig: {
              "sections": [
                  {
                      "isMandatory": true,
                      "rows": [
                          {
                              "properties": [
                                  {
                                      "label": "First name",
                                      "type": "textfield",
                                      "isMandatory": "isMandatory",
                                      "data": "firstName"
                                  }, {
                                      "label": "Last name",
                                      "type": "textfield",
                                      "isMandatory": "isLastNameMandatory",
                                      "data": "lastName"
                                  }
                              ]    
                          }
                      ]
                  }
              ]
          },
          "rules": [
              {
                  "rule": "this.firstName == \"Sushant\" && this.lastName != \"Ahirrao\"",
                  "error": "First name and last name combination is not matching"
              }
          ]
      };
  Usage:
      <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>
      
 * @example
 Form widget without widget panel (right panel):
 <smart-form-widget show-widget="false"></smart-form-widget>   
     
 * @example
 If newly added ui elements (fields) to be added at the end of the section:
 <smart-form-widget is-sequencial="true"></smart-form-widget>
 
 * @example
 Widget-panel with top and right position:
 <smart-form-widget widget-panel-top="100" widget-panel-right="70"></smart-form-widget>    
 
 * @example
 Form widget with 'Rule Engine' service:
 Controller:
      $scope.config = {
          modelData: {
              "firstName": "Sushant",
              "lastName": "Ahirrao"
          },    
          formConfig: {
              "sections": [
                  {
                      "isMandatory": true,
                      "rows": [
                          {
                              "properties": [
                                  {
                                      "label": "First name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "firstName"
                                  }, {
                                      "label": "Last name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "lastName"
                                  }
                              ]    
                          }
                      ]
                  }
              ]
          },
          "rules": [
              {
                  "rule": "this.firstName == \"Sushant\" && this.lastName != \"Ahirrao\"",
                  "error": "First name and last name combination is not matching"
              }
          ]
      };

      $scope.validateForm = function() {
          RuleEngine.setRules($scope.config.formConfig.sections, $scope.config.modelData, $scope.config.rules);
          RuleEngine.execute(function (e) {
              console.log(e);   //  Check e for more details
          }, $scope);  
      };
  Usage:
      <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>
      <button ng-click="validateForm()">Validate Form</button>

* @example
Saving sections on outside section click.

mandatoryFieldStatus property used to initiate sec Nav validation and section indicator

 Dynamic:
 Controller:
      $scope.config = {
          modelData: {
              "firstName": "Sushant",
              "lastName": "Ahirrao"
          },    
          formConfig: {
              "sections": [
                  {
                      "isMandatory": true,
                        "save":true,
                        "mandatoryFieldStatus": {
                            "status": "complete",
                            "isvalidate":  false,
                            "description": "There are some mandatory fields that are not filled in this section",
                            "title": "Section 3 - Completed" 
                        },
                      "rows": [
                          {
                              "properties": [
                                  {
                                      "label": "First name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "firstName"
                                  }, {
                                      "label": "Last name",
                                      "type": "textfield",
                                      "isMandatory": true,
                                      "data": "lastName"
                                  }
                              ]    
                          }
                      ]
                  }
              ]
          },
          "rules": [
              {
                  "rule": "this.firstName == \"Sushant\" && this.lastName != \"Ahirrao\"",
                  "error": "First name and last name combination is not matching"
              }
          ]
      };
	  $scope.onSave = function (data, prevObj) {
	      console.log(data, "In Controller ", prevObj)
          $scope.$digest();
		  // Note: data will give scope.modelData Obj and prevObj will give scope.formConfig.sections[..]
		  // use class="savable" in actionable container within the section for avoiding the onSave callback function. 
	  };
  Usage:
      <smart-form-widget form-config="config.formConfig" model-data="config.modelData" on-save="onSave(data, prevObj)"></smart-form-widget>


 */

(function () {
    'use strict';
    var formWidgetCounter = 0;
    angular.module('SMART2').directive('smartFormWidget', ['APPCONSTANTS', 'ScrollTo', 'formWidgetUtils', '$translate', '$timeout', '$compile', 'persistenceService', function (APPCONSTANTS, ScrollTo, formWidgetUtils, $translate, $timeout, $compile, persistenceService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                formConfig: '=?',
                modelData: '=?',
                isSequential: '@',
                showWidget: '@',
                searchHolder: '@',
                widgetPanelTop: '@',
                widgetPanelRight: '@',
                onSectionSort: '&',
                onSave: '&',
                revisionMode:"@",
                secNav: '=?',
                filterWith: '=?'
            },
            link: function (scope, element, attrs) {
                if (scope.secNav == undefined) {
                    scope.secNav = true
                }
                scope.widgetPanelRightPos = scope.widgetPanelRight ? parseFloat(scope.widgetPanelRight) : 70;
                formWidgetCounter = formWidgetCounter + 1;
                scope.formWidgetId = 'form-widget-' + formWidgetCounter;

                scope.visibleSectionTrackerItemsCount = 0;

                var currentSelectedSection = 0;
                var sectionItemClicked = false;
                var optionalSectionClicked = false;
                scope.enableFieldPreview = false;

                /*
                 *  Update visible section tracker items
                 */
                var updateVisibleSectionTrackerItemsCount = function () {
                    var count = 0,
                        len = scope.sectionTrackerItems.length;
                    for (var i = 0; i < len; i++) {
                        var tItem = scope.sectionTrackerItems[i];
                        if (tItem.visible && !tItem.hidden) {
                            count++;
                        }
                    }
                    scope.visibleSectionTrackerItemsCount = count;
                };


                var onSubHeaderHeight = attrs.$observe('subHeaderHeight', function (value) {
                    if (!isNaN(value)) {
                        ScrollTo.setScrollingTopMargin(parseInt(value));
                    }
                });


                scope.isFormWidgetToBeLoaded = false;

                var toutPromise = $timeout(function () {
                    scope.isFormWidgetToBeLoaded = true;
                    $timeout.cancel(toutPromise);
                    toutPromise = null;
                }, 500);



                scope.checkPresistence = false;
                scope.getPresistence = function (formConfig) {
                    if (formConfig && typeof formConfig.documentType != 'undefined') {
                        persistenceService.getUserData(formConfig.documentType);
                        persistenceService.sectionPersistence.getSectionsPersistence(formConfig, persistenceService.userData);
                    }
                }

                scope.modelDataWatcherEnabledOrNot = false;
                scope.initModelDataWatcher = function (newConfig) {
                    scope.modelDataWatcherEnabledOrNot = true;
                    scope.unbindModelDataWatcher = scope.$watch('modelData', function (newVal, oldVal) {

                        persistenceService.getModelData(newConfig, newVal, scope.unbindModelDataWatcher, scope.initChipsWatcher);
                    }, true);
                }
                var persistenceTimeout;
                scope.initChipsWatcher = function (arr) {

                    scope.$watchGroup(arr, function (newVal, oldVal) {
                        persistenceService.nPlusOne.getSelectedSection();
                        if (persistenceTimeout) {
                            $timeout.cancel(persistenceTimeout);
                            persistenceTimeout = undefined;
                        }
                        persistenceTimeout = $timeout(function () {
                            persistenceService.saveRecentDocument(newVal, scope.modelData);
                        }, 1000);

                    });
                }

                var unbindSectionsLoadedWathcer;
                function initSectionsLoadedWatcher() {
                    scope.SectionLoaderInitiated = true;
                    var arr = [];
                    for (var i = 0; i < scope.formConfig.sections.length; i++) {
                        arr.push('formConfig.sections[' + i + '].isContentLoaded');
                    }


                    unbindSectionsLoadedWathcer = scope.$watchGroup(arr, function (newVal, oldVal) {
                        if (newVal) {
                            var loadedCompletely = false;
                            for (var i = 0; i < newVal.length; i++) {
                                if (newVal[i] == false && !scope.formConfig.sections[i].isLazyLoadEnabled) {
                                    break;
                                }
                                if (i == newVal.length - 1 && (newVal[i] == true || typeof newVal[i] == 'undefined')) {
                                    scope.initSectionFocus();
                                    var seclectedSectionId = persistenceService.nPlusOne.getSelectedSection();
                                    if (seclectedSectionId != '') {
                                        var seclectedSectionIndex = -1;
                                        var sections = scope.formConfig.sections;
                                        for (var j = 0; j < sections.length; j++) {
                                            if (typeof sections[j].id != 'undefined' && sections[j].id == seclectedSectionId) {
                                                seclectedSectionIndex = j;
                                                //sections[j].isActive = true;
                                                break;
                                            }
                                        }

                                        loadedCompletely = true;
                                        if (seclectedSectionIndex > -1) {
                                            sectionItemClicked = true;
                                            var mySection = scope.sectionTrackerItems[seclectedSectionIndex];
                                            if (mySection.visible) {
                                                scope.sectionTrackerItems[currentSelectedSection].isActive = false;
                                                mySection.isActive = true;
                                                currentSelectedSection = seclectedSectionIndex;


                                            }
                                            
                                            scope.isSectionsLoaded = false;
                                            ScrollTo.perform(element.find('#' + scope.formWidgetId + '-section-' + seclectedSectionIndex), angular.element('#' + scope.formWidgetId), function (e) {
                                                setTimeout(function () {
                                                    sectionItemClicked = false;
                                                    scope.isSectionsLoaded = true;
                                                }, 250);

                                                // scope.sectionsLoadedCompletely = true;
                                                unbindSectionsLoadedWathcer();
                                            });
                                        }
                                        else {
                                            scope.isSectionsLoaded = true;
                                        }
                                    }
                                    else {
                                        scope.isSectionsLoaded = true;
                                    }
                                }
                            }
                        }
                    });
                }






                var formWidgetTimeout;

                //var firstTime;
                var onFormConfig = scope.$watch('formConfig', function (newConfig, oldConfig) {
                    if (newConfig) {
                        if (formWidgetTimeout) {
                            $timeout.cancel(formWidgetTimeout);
                            formWidgetTimeout = undefined;
                        }

                        if (scope.checkPresistence != true) {
                            scope.getPresistence(newConfig);
                            scope.formConfig.sections=newConfig.sections;
                            scope.checkPresistence = true;
                        }

                        if (scope.modelDataWatcherEnabledOrNot == false && newConfig != undefined) {
                            scope.initModelDataWatcher(newConfig);

                        }

                        formWidgetTimeout = $timeout(function () {
                            var sectionItems = [];
                            var optionalSections = [];
                            var optionalFieldsAndSections = [],
                                sectionLen = scope.formConfig.sections.length;

                            scope.enableFieldPreview = newConfig.enableFieldPreview;

                            for (var i = 0; i < sectionLen; i++) {
                                var tSection = scope.formConfig.sections[i];
                                //  if (firstTime || !angular.equals(newConfig.sections[i], (typeof oldConfig === 'undefined') ? null : oldConfig.sections[i])) {
                                tSection.isMandatory = formWidgetUtils.convertAndGetValue(tSection.isMandatory, scope, tSection);
                                if (angular.isDefined(tSection.isVisible)) {
                                    tSection.isVisible = formWidgetUtils.convertAndGetValue(tSection.isVisible, scope, tSection);
                                }
                                else {
                                    tSection.isVisible = tSection.isMandatory;
                                }
                                if (!angular.isDefined(tSection.isHidden)) {
                                    //tSection.isHidden = scope.formConfig.sections[i].isHidden; //[TODO] not needed code
                                    tSection.isHidden = false;
                                } //else {
                                //tSection.isHidden = false;
                                //}
                                tSection.key = scope.formWidgetId + '-section-' + i;

                                if (scope.$eval(scope.showWidget) != false) {
                                    sectionItems.push({
                                        label: tSection.label,
                                        sectionIndex: i,
                                        visible: tSection.isVisible,
                                        hidden: tSection.isHidden,
                                        isActive: i == currentSelectedSection,
                                        save: tSection.save,
                                        id: tSection.id || '',
                                        mandatoryFieldStatus: tSection.mandatoryFieldStatus,
                                        isReadOnly: tSection.isReadOnly
                                    });
                                }

                                if (!tSection.isMandatory && scope.$eval(scope.showWidget) != false && !tSection.isHidden) {
                                    optionalSections.push({
                                        label: tSection.label,
                                        searchLabel: $translate.instant(tSection.label),
                                        sectionIndex: i,
                                        visible: false,
                                        hidden: scope.formConfig.sections[i].isHidden,
                                        isActive: false,
                                        isSection: true,
                                        save: tSection.save,
                                        mandatoryFieldStatus: tSection.mandatoryFieldStatus,
                                        isReadOnly: tSection.isReadOnly
                                    });
                                }

                                var sectionOptionalFields = [],
                                    rowsLength = tSection.rows.length;

                                for (var j = 0; j < rowsLength; j++) {
                                    var trowsData = tSection.rows[j],
                                        propertyLen = trowsData.properties.length;
                                    for (var k = 0; k < propertyLen; k++) {
                                        var tProperty = trowsData.properties[k];
                                        tProperty.isMandatory = formWidgetUtils.convertAndGetValue(tProperty.isMandatory, scope, tProperty);
                                        if (angular.isDefined(tProperty.isVisible)) {
                                            tProperty.isVisible = formWidgetUtils.convertAndGetValue(tProperty.isVisible, scope, tProperty);
                                        }
                                        else {
                                            tProperty.isVisible = tProperty.isMandatory;
                                        }
                                        if (angular.isDefined(tProperty.isHidden)) {
                                            tProperty.isHidden = formWidgetUtils.convertAndGetValue(tProperty.isHidden, scope, tProperty);
                                        }
                                        if (!tProperty.isMandatory && scope.$eval(scope.showWidget) != false && !tProperty.isHidden) {
                                            sectionOptionalFields.push({
                                                sectionKey: tSection.key,
                                                label: tProperty.label,
                                                sectionLabel: tSection.label,
                                                searchLabel: $translate.instant(tSection.label) + ' ' + $translate.instant(tProperty.label),
                                                sectionIndex: i,
                                                rowIndex: j,
                                                propertyIndex: k,
                                                visible: tProperty.isVisible,
                                                isSection: false
                                            });
                                        }
                                    }
                                }

                                tSection.optionalFields = sectionOptionalFields;
                                optionalFieldsAndSections = optionalFieldsAndSections.concat(tSection.optionalFields);
                                //}
                            }
                            //  firstTime = false;
                            scope.sectionTrackerItems = sectionItems;

                            if (!optionalSectionClicked)
                                scope.optionalSections = optionalSections;

                            optionalFieldsAndSections = scope.optionalSections.concat(optionalFieldsAndSections);

                            scope.optionalFieldsAndSections = optionalFieldsAndSections;

                            updateVisibleSectionTrackerItemsCount();

                            scope.showWidget = scope.sectionTrackerItems.length > 1 || scope.optionalSections.length > 0;
                            if (!scope.SectionLoaderInitiated) {
                                initSectionsLoadedWatcher();
                            }
                        }, 250);
                    }
                }, true);
                /*
                *  If search is enabled 
                */
                //caching the selector.
                var searchHolder = angular.element('#' + scope.searchHolder);
                if (searchHolder.length > 0) {
                    searchHolder.html('<div ng-include="\'shared/directives/uiElements/smartFormWidget/searchTemplate.html\'"></div>');
                    $compile(searchHolder.contents())(scope);
                }

                function getOpenWidgetSection(a_id) {
                    var returnItem = false,
                        len = scope.formConfig.sections.length;
                    for (var indx = 0; indx < len; indx++) {
                        var tmpObj = scope.formConfig.sections[indx];
                        if (tmpObj.id === a_id) {
                            returnItem = tmpObj;
                            break;
                        }

                    }
                    return returnItem;
                }
                var onDocumentScroll = function () {
                    if (filterTextTimeout) {
                        $timeout.cancel(filterTextTimeout);
                    }

                    filterTextTimeout = $timeout(function () {
                        try {
                            var formWidgetTop = angular.element('#' + scope.formWidgetId).offset().top + 100;
                            if (!sectionItemClicked && scope.isSectionsLoaded) {
                                var scrollTop = $(window).scrollTop(),
                                    trackerItemsLen = scope.sectionTrackerItems.length;
                                for (var i = 0; i < trackerItemsLen; i++) {
                                    var $this = element.find('#' + scope.formWidgetId + '-section-' + i);

                                    // Position of section relative to window
                                    if ($this.children().length > 0) {
                                        var offset = $this.offset().top;
                                        //get index of div in the parent document
                                        if (scrollTop >= (offset - formWidgetTop)) {
                                            newSelected = i;
                                            //break;
                                        }
                                    }
                                    $this = null;
                                }
                                if (scrollTop + $(window).height() == $(document).height()) {
                                    newSelected = trackerItemsLen - 1;
                                }
                                if (scope.sectionTrackerItems[newSelected].visible) {
                                    scope.sectionTrackerItems[currentSelectedSection].isActive = false;
                                    scope.sectionTrackerItems[newSelected].isActive = true;
                                    currentSelectedSection = newSelected;
                                    if (typeof scope.sectionTrackerItems[newSelected].id != 'undefined') {
                                        persistenceService.nPlusOne.saveSelectedSection(scope.sectionTrackerItems[newSelected].id);
                                    }
                                }
                            }
                        }
                        catch (e) { }
                    }, 100);
                };
                if (scope.$eval(scope.showWidget) != false) {
                    var windowHeight = $(window).height();
                    var newSelected = 0;
                    var filterTextTimeout = null;
                    $(document).on('scroll', onDocumentScroll);


                    /*
                     * Section item click handler
                     */
                    scope.onSectionItemClick = function (item, sectionNumber) {
                        var sectionTrackerLength = scope.sectionTrackerItems.length;
                        //  For loop is needed in this case, because it is difficult to maintain the index of dragged/dropped item.
                        for (var i = 0; i < sectionTrackerLength; i++) {
                            scope.sectionTrackerItems[i].isActive = false;
                        }
                        scope.sectionTrackerItems[sectionNumber].isActive = true;
                        currentSelectedSection = sectionNumber;
                        var Selectedsection = scope.formConfig.sections[item.sectionIndex];
                        Selectedsection.isActive = true;
                        if (typeof Selectedsection.id != 'undefined') {
                            persistenceService.nPlusOne.saveSelectedSection(Selectedsection.id);
                        }
                        sectionItemClicked = true;
                        ScrollTo.perform(element.find('#' + scope.formWidgetId + '-section-' + item.sectionIndex), angular.element('#' + scope.formWidgetId), function (e) {
                            sectionItemClicked = false;
                        });
                    };


                    /*
                     * On optional section item click handler
                     */
                    scope.onOptionalSectionItemClick = function (isLabelClicked, item) {
                        if (isLabelClicked && item.isVisible) {
                            return;
                        }

                        scope.formConfig.sections[item.sectionIndex].isVisible = !scope.formConfig.sections[item.sectionIndex].isVisible;
                        optionalSectionClicked = true;
                        //  Toggle section tracker item visibility
                        var trackerTLen = scope.sectionTrackerItems.length;
                        for (var i = 0; i < trackerTLen; i++) {
                            if (scope.sectionTrackerItems[i].label === item.label) {
                                scope.sectionTrackerItems[i].visible = !item.visible;
                                break;
                            }
                        }

                        /*
                         *  scope.isSequential is set to 'true', form-widget-section would be added 
                         *  where it is positioned in the JSON structure else 
                         *  form-widget-section would be added at the end of row
                         */
                        if (!scope.$eval(scope.isSequential) && scope.formConfig.sections[item.sectionIndex].isVisible) {
                            //  Re-arrange sections order
                            var tmpSection = scope.formConfig.sections[item.sectionIndex];
                            scope.formConfig.sections.splice(item.sectionIndex, 1);
                            scope.formConfig.sections.push(tmpSection);

                            //  Re-arrange sections tracker items order
                            for (var i = 0; i < scope.sectionTrackerItems.length; i++) {
                                if (scope.sectionTrackerItems[i].label === item.label) {
                                    var tmpSection = scope.sectionTrackerItems[i];
                                    scope.sectionTrackerItems.splice(i, 1);
                                    scope.sectionTrackerItems.push(tmpSection);
                                    break;
                                }
                            }

                            //  Re-arrange sections tracker items section index
                            for (var i = 0; i < scope.formConfig.sections.length; i++) {
                                for (var j = 0; j < scope.sectionTrackerItems.length; j++) {
                                    if (scope.formConfig.sections[i].label == scope.sectionTrackerItems[j].label) {
                                        scope.sectionTrackerItems[j].sectionIndex = i;
                                    }
                                }
                            }

                            //  Re-arrange sections optional fields section index
                            for (var i = 0; i < scope.formConfig.sections.length; i++) {
                                for (var j = 0; j < scope.optionalSections.length; j++) {
                                    if (scope.formConfig.sections[i].label == scope.optionalSections[j].label) {
                                        scope.optionalSections[j].sectionIndex = i;
                                    }
                                }
                            }
                        }
                        item.visible = !item.visible;
                        var tempTOut = setTimeout(function () {
                            if (item.visible) {
                                ScrollTo.perform(element.find('#' + scope.formWidgetId + '-section-' + item.sectionIndex), angular.element('#' + scope.formWidgetId));
                            }
                            clearTimeout(tempTOut);
                        }, 200);

                        updateVisibleSectionTrackerItemsCount();
                    };


                    scope.onOptionalFieldClick = function (isLabelClicked, item) {
                        if (!item.visible) {
                            ScrollTo.perform(element.find('#' +scope.formWidgetId + '-section-' + item.sectionIndex), angular.element('#' +scope.formWidgetId));
                        }
                        scope.$broadcast('optionalFieldClick', { isLabelClicked: isLabelClicked, item: item });
                    };


                    /*
                     * Widget panel
                     */
                    scope.showWidgetPanel = false;

                    scope.toggleWidgetPanel = function () {
                        scope.showWidgetPanel = !scope.showWidgetPanel;
                    };


                    /*
                     *  Callback function when section order gets changed
                     */
                    scope.onSort = function (e) {
                        var tmpSectionItems = angular.copy(scope.sectionTrackerItems);
                        var item = tmpSectionItems.splice(e.startIndex, 1);
                        tmpSectionItems.splice(e.endIndex, 0, item[0]);
                        scope.sectionTrackerItems = angular.copy(tmpSectionItems);
                        tmpSectionItems = null;
                        var formConfigAfterSort = [],
                            trackerSortLen = scope.sectionTrackerItems.length;
                        var sectionsList = [];
                        for (var i = 0; i < trackerSortLen; i++) {
                            var section = scope.formConfig.sections[scope.sectionTrackerItems[i].sectionIndex];
                            formConfigAfterSort.push(section);
                            if (typeof section.id != 'undefined') {
                                sectionsList.push(section.id);
                            }
                        }
                        if (sectionsList.length > 0 && typeof scope.formConfig.documentType != 'undefined') {
                            persistenceService.updateUserData('sections', sectionsList);
                            persistenceService.saveUserData(scope.formConfig.documentType);
                        }
                        scope.onSectionSort({
                            $event: { formConfig: formConfigAfterSort }
                        });
                    };


                    /*
                     *  Make section active in section tracker
                     */
                    var previousClickedSection = [];
                    scope.initSectionFocus = function () {
                        scope.$on('sectionFocus', function (event, data) {
                            var openedSec = getOpenWidgetSection(data.id);
                            var sectionNumber = openedSec.sectionIndex;
                            if (openedSec) {
                                scope.onSectionItemClick(openedSec, sectionNumber);
                            }
                        });
                    }


                    scope.onSectionClick = function (section) {
                        if (attrs.onSave) {
                            if (section.hasOwnProperty('save') && section != previousClickedSection[(previousClickedSection.length - 1)]) {
                                previousClickedSection.push(section);
                            }

                            if (previousClickedSection.length > 2) {
                                previousClickedSection.shift();
                            }
                        }
                        if (scope.sectionTrackerItems[currentSelectedSection].label === section.label) {
                            return;
                        }
                        var tlenTracker = scope.sectionTrackerItems.length;
                        for (var i = 0; i < tlenTracker; i++) {
                            if (scope.sectionTrackerItems[i].label === section.label) {
                                scope.sectionTrackerItems[currentSelectedSection].isActive = false;
                                scope.sectionTrackerItems[i].isActive = true;
                                currentSelectedSection = i;
                                if (typeof scope.sectionTrackerItems[i].id != 'undefined') {
                                    persistenceService.nPlusOne.saveSelectedSection(scope.sectionTrackerItems[i].id);
                                }
                                break;
                            }
                        }
                    };


                    /*
                     *  Callback function when user expands or collapses the section
                     */
                    scope.onSectionHeaderClick = function (section) {
                        if (angular.isDefined(section.onHeaderClick)) {
                            eval('scope.' + formWidgetUtils.generateFunctionWithParams(section.onHeaderClick, '$parent', true));
                        }
                        if (!section.isContentLoaded) {
                            section.isContentLoaded = true;
                        }
                    };


                    // Auto Save Callback
                    if (attrs.onSave) {
                        var onDocumentClick = function (e) {
                            if (!previousClickedSection.length) {
                                return;
                            }
                            var prevKeyLen = $(e.target).closest('#' + previousClickedSection[0].key).length;
                            if ((!prevKeyLen) || (prevKeyLen && $(e.target).closest('.savable').length)) {
                                if (!$(e.target).closest('.modal').length && !$(e.target).closest('.noSaveItem').length && !$(e.target).closest('.lean-overlay').length) {
                                    scope.onSave({ data: scope.modelData, prevObj: previousClickedSection[0] });
                                    previousClickedSection.shift();
                                }
                                //scope.$digest();
                            }
                        }

                        $(document).off('click.saveSection').on('click.saveSection', onDocumentClick);

                        // Needed due to selectbox plugin using stopPropagation
                        $(document).off('change.saveSelect').on('change.saveSelect', '.select-wrapper select', function (e) {
                            //var ind = $('#' + scope.formWidgetId + '-sortable').children('li').index($(this).closest('li')),
                            //    sectionDatastore = scope.formConfig.sections[ind];


                            var ind = $(this).closest('.card.cardParent').attr('id').split('section-'),
                                sectionDatastore = scope.formConfig.sections[ind[1]];
                            if (sectionDatastore.hasOwnProperty('save') && sectionDatastore != previousClickedSection[(previousClickedSection.length - 1)]) {
                                previousClickedSection.push(sectionDatastore);
                            }

                            if (previousClickedSection.length > 2) {
                                previousClickedSection.shift();
                            }

                            onDocumentClick(e);
                        });
                    }

                    /*
                     *  Remove all listeners on scope destroy
                     */
                    scope.$on('$destroy', function () {
                        $(document).off('scroll');
                        $(document).off('click.saveSection');
                        $(document).off('change.saveSelect')
                        onSubHeaderHeight();
                        onFormConfig();
                        //   scope.formConfig.sections = null;
                        //   scope.formWidgetId = null;
                        //  scope.sectionTrackerItems = null;
                    });


                    scope.iconClasses = APPCONSTANTS.formWidgetItemClasses;
                }
            },
            templateUrl: 'shared/directives/uiElements/smartFormWidget/smartFormWidgetTemplate.html'
        };
    }]);


    angular.module('SMART2').directive('smartSvgIcon', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + attrs.smartSvgIcon + '"></use></svg>');
            }
        };
    }]);


    /*
     *  Text highlighting filter
     */
    angular.module('SMART2').filter('highlight', ['$sce', function ($sce) {
        return function (text, phrase) {
            if (phrase) {
                text = text.replace(new RegExp('(' + phrase + ')', 'gi'), '<span style="background: yellow">$1</span>');
            }
            return $sce.trustAsHtml(text);
        }
    }]);
})();
